__turbopack_context__.v({
  "defaultBadge": "oUp03G_defaultBadge",
  "tabsList": "oUp03G_tabsList",
});
